import { render, staticRenderFns } from "./SB2Button.vue?vue&type=template&id=a5e545c2&"
import script from "./SB2Button.vue?vue&type=script&lang=js&"
export * from "./SB2Button.vue?vue&type=script&lang=js&"
import style0 from "./SB2Button.vue?vue&type=style&index=0&id=a5e545c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports